// arctic-announcement-savings — wraps the announcement-bar NNC savings slot.
//
// Why: Northbound's runtime writes formatMoney(0) into
// [data-northbound-savings-display] on every cart-pricing tick when no
// community is selected, the cart is empty, or subsidyCents <= 0. The
// theme's :empty CSS gate never fires because the span is never empty.
//
// This element listens for `northbound:cart-pricing-applied` and toggles
// `hidden` on the wrapper `[data-northbound-slot="savings"]` so the
// "you're saving $0.00" line stays out of view until there's a positive
// subsidy. Adapted from horizon/assets/announcement-nnc-bar.js.

(() => {
  if (customElements.get('arctic-announcement-savings')) return;

  class ArcticAnnouncementSavings extends HTMLElement {
    connectedCallback() {
      this.parentItem = this.closest('[data-northbound-slot="savings"]');
      this.applyState(this.readSubsidyCents());

      this.onPricingApplied = (event) => {
        const result = event && event.detail && event.detail.cartPricingResult;
        const cents = this.toCents(result && result.subsidyCents);
        this.applyState(cents);
      };
      this.onCommunityChanged = () => this.applyState(this.readSubsidyCents());

      window.addEventListener('northbound:cart-pricing-applied', this.onPricingApplied);
      window.addEventListener('northbound:community-changed', this.onCommunityChanged);
    }

    disconnectedCallback() {
      window.removeEventListener('northbound:cart-pricing-applied', this.onPricingApplied);
      window.removeEventListener('northbound:community-changed', this.onCommunityChanged);
    }

    readSubsidyCents() {
      const api = window.NorthboundStorefront;
      if (!api || typeof api.getCartPricingResult !== 'function') return 0;
      try {
        const result = api.getCartPricingResult();
        return this.toCents(result && result.subsidyCents);
      } catch (err) {
        return 0;
      }
    }

    toCents(value) {
      const n = Number(value);
      return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
    }

    applyState(subsidyCents) {
      if (!this.parentItem) return;
      this.parentItem.hidden = subsidyCents <= 0;
    }
  }

  customElements.define('arctic-announcement-savings', ArcticAnnouncementSavings);
})();
